import { graphql } from '@mp/graphql/generated';
import { useCurrentUser } from '@mp/hooks';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';
import { type ResultOf } from '@graphql-typed-document-node/core';

export const AssignmentRequestsGql = graphql(`
  query GetAssignmentRequestsForAdditionalDetails($input: AssignmentRequestQueryInput) {
    assignmentRequests(input: $input) {
      id
      status
    }
  }
`);

type AssignmentRequestsProps = ResultOf<typeof AssignmentRequestsGql>;

export const useAssignmentRequestsForAssignmentAdditionalDetailsGroup = (
  assignment_id?: number,
) => {
  const { currentUser } = useCurrentUser();
  const enabled = assignment_id === undefined ? true : !!assignment_id;
  const professional_id = currentUser?.professional?.id;
  const queryKey = ['assignmentRequests', assignment_id, professional_id];

  const { data, isLoading } = useGraphQLQuery<AssignmentRequestsProps>({
    operationName: 'GetAssignmentRequestsForAdditionalDetails',
    queryKey,
    query: AssignmentRequestsGql,
    variables: {
      input: { filter: { assignment_id }, orderBy: { updated_at: false } },
      professional_id,
    },
    enabled,
  });
  const assignmentRequests = data?.assignmentRequests || [];

  return { assignmentRequests, isLoading };
};
